<script setup>
import ResetPassword from "@/components/parent/ResetPassword.vue";
</script>

<template>
  <ResetPassword />
</template>
